import React from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
// import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import CustomFormLabel from "../../components/forms/custom-elements/CustomFormLabel";
import PageContainer from "../../components/container/PageContainer";
import { Form, useFormik, FormikProvider } from "formik";
import { changePasswordSchema, resetPasswordSchema } from "../../validationSchema/ChangePassword";
import CustomTextField from "../../components/forms/custom-elements/CustomTextField";
import { SaveChangePassword } from "../../services/user";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { routes } from "./../../routes/routes.tsx";
import useQuery from "../../custom-hooks/useQuery";
import { StoreNewPassword } from "../../services/auth";

const NewPassword = () => {
  let navigate = useNavigate();
  const [values, setValues] = React.useState({
    password: "",
    currentPassword: false,
    showPassword: false,
    confirmPassword: false,
  });
  let query = useQuery()
  const viewValue = query.get("u");
  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: resetPasswordSchema,
    onSubmit(values, { resetForm }) {
      handleChangePasswordData(values, resetForm);
    },
  });

  const handleChangePasswordData = async (data, resetForm) => {
    try {
      const response = await StoreNewPassword(viewValue, data.newPassword);
      if (response?.status === 200) {
        toast.success("Password changed succesfully");
        resetForm();
        localStorage.clear();
        navigate(routes?.login?.match);
        window.location.reload();
      }
    } catch (e) {}
  };

  const handleClickCurrentPassword = () => {
    setValues({ ...values, currentPassword: !values.currentPassword });
  };
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleClickConfirmPassword = () => {
    setValues({ ...values, confirmPassword: !values.confirmPassword });
  };

  const { getFieldProps, errors, touched } = formik;

  return (
    <PageContainer
      title="Reset Password"
      description="this is Reset Password page"
    >
      <FormikProvider value={formik}>
        <Form>
          <Grid
            container
            spacing={0}
            sx={{ height: "70vh", justifyContent: "center" }}
          >
            <Grid item xs={12} sm={8} lg={6} display="flex" alignItems="center">
              <Grid
                container
                spacing={0}
                display="flex"
                justifyContent="center"
              >
                <Grid item xs={12} lg={9} xl={6}>
                  <Box
                    sx={{
                      p: 0,
                    }}
                  >
                    <Typography variant="h2" fontWeight="700">
                      Change your password?
                    </Typography>
                    <Box
                      sx={{
                        mt: 4,
                      }}
                    >
                      <CustomFormLabel htmlFor="newPassword">
                        &nbsp;
                      </CustomFormLabel>
                      <CustomTextField
                        id="newPassword"
                        name="newPassword"
                        type={values.showPassword ? "text" : "password"}
                        variant="outlined"
                        placeholder="New Password"
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={handleClickShowPassword}>
                                {values.showPassword ? (
                                  <FeatherIcon icon="eye" width="16" />
                                ) : (
                                  <FeatherIcon icon="eye-off" width="16" />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        {...getFieldProps("newPassword")}
                        helperText={touched.newPassword && errors.newPassword}
                        error={Boolean(
                          touched.newPassword && errors.newPassword
                        )}
                      />

                      <CustomFormLabel htmlFor="confirmPassword">
                        &nbsp;
                      </CustomFormLabel>
                      <CustomTextField
                        id="confirmPassword"
                        variant="outlined"
                        fullWidth
                        type={values.confirmPassword ? "text" : "password"}
                        placeholder="Confirm Password"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={handleClickConfirmPassword}>
                                {values.confirmPassword ? (
                                  <FeatherIcon icon="eye" width="16" />
                                ) : (
                                  <FeatherIcon icon="eye-off" width="16" />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        {...getFieldProps("confirmPassword")}
                        helperText={
                          touched.confirmPassword && errors.confirmPassword
                        }
                        error={Boolean(
                          touched.confirmPassword && errors.confirmPassword
                        )}
                      />

                      <Button
                        color="secondary"
                        variant="contained"
                        size="large"
                        fullWidth
                        // component={Link}
                        // to="/"
                        type="submit"
                        sx={{
                          pt: "10px",
                          pb: "10px",
                          mt: 4,
                        }}
                      >
                        Change Password
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      </FormikProvider>
    </PageContainer>
  );
};
export default NewPassword;
